module.exports = __webpack_public_path__ + "img/gratitude-journal_B095KX79BR.b124d77d.jpg";